<button mat-raised-button color="primary" *appRole="['Contratos.GeneraLiquidacion']" #tooltip="matTooltip" matTooltip="Generación de liquidaciones." class="btn-nuevo" (click)="openDialogNuevaLiquidacion()">
  <mat-icon>change_circle</mat-icon>
  Generar liquidaciones
</button>
<br>
<br>
<app-liquidaciones-generadas *appRole="['Contratos.Ver']" [liquidacionesGeneradas]="liquidacionesGeneradas"></app-liquidaciones-generadas>
